module.exports = __webpack_public_path__ + "static/media/Yellow-browed bulbul template.3c939b5b.mp4";